/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cascade_Dialog_Error_Group_Count_MismatchInputs */



/**
* | output |
* | --- |
* | "The number of groups must correspond to the number of unique production groups" |
*
* @param {Cascade_Dialog_Error_Group_Count_MismatchInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const cascade_dialog_error_group_count_mismatch = /** @type {((inputs?: Cascade_Dialog_Error_Group_Count_MismatchInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cascade_Dialog_Error_Group_Count_MismatchInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The number of groups must correspond to the number of unique production groups")
	return /** @type {LocalizedString} */ ("Le nombre de groupes doit correspondre au nombre de groupes de productions uniques")
});